import { React, useCallback } from "react";
import styled from "styled-components";
import { Form, Input } from "antd";
import { HaberForm } from "../../../Pages/styledElements";
import SearchIcon from "../../../Assets/Icons/search.svg";
import AlertSummaryTableContainer from "./orderSummaryTableAlert";
import alertRed from "../../../Assets/Icons/alertRed.svg";

const SearchBarHeader = styled.div`
  .searchBoxWrap {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
  }
  .searchWidth {
    width: 38%;
    .ant-row {
      margin: 0;
    }
    .ant-col {
      input[type="text"] {
        padding-left: 15px !important;
      }
    }
    .ant-form-item {
      margin-bottom: 0;
    }
    .searchIcon {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        background-size: contain;
        background-repeat: no-repeat;
        z-index: 2;
        right: 10px;
        top: 12px;
        width: 22px;
        height: 17px;
        background-image: url(${SearchIcon});
      }
    }
  }
  .exportDataBtn {
    align-self: center;
    button {
      &:last-child {
        margin-right: 0px;
      }
      svg {
        top: 3px;
      }
    }
  }
  .themeBtn {
    margin: 0px 6px !important;
  }
`;

const OrderSummaryHeader = ({
  placeholder,
  fetchOrder,
  selected_type,
  totaSelectedOrders,
  totalQuantity,
}) => {
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        func.apply(context, args);
      }, wait);
    };
  }
  const debounceOnChange = useCallback(debounce(fetchOrder, 300), []);

  return (
    <SearchBarHeader>
      {/* <AlertSummaryTableContainer
        color="red"
        icon={alertRed}
        msg="You have 3 alerts regarding the selection of orders"
        button="View all alerts"
      /> */}
      <div className="searchBoxWrap">
        <HaberForm className="searchWidth">
          <Form name="basic" autoComplete="off" className="haberLogin">
            <Form.Item name="username" className="searchIcon">
              <Input
                placeholder={placeholder}
                onChange={(e) => {
                  debounceOnChange(e.target.value);
                }}
              />
            </Form.Item>
          </Form>
        </HaberForm>
        {selected_type && selected_type !== "cutting" && totaSelectedOrders ? (
          <div className="exportDataBtn">
            <span className="textTypeBtn textBtnIcon">
              Total selected orders : {totaSelectedOrders}
            </span>
          </div>
        ) : null}
        {selected_type && selected_type !== "cutting" && totalQuantity ? (
          <div className="exportDataBtn">
            <span className="textTypeBtn textBtnIcon">
              Quantity : {totalQuantity}
            </span>
          </div>
        ) : null}
      </div>
    </SearchBarHeader>
  );
};
export default OrderSummaryHeader;
